import Parallax_1 from "../../../Assets/parallax_1.png";
import Parallax_2 from "../../../Assets/parallax_2.png";
import Parallax_3 from "../../../Assets/parallax_3.png";
import Parallax_4 from "../../../Assets/parallax_4.png";
import * as S from "./style";

export const Parallax = () => {

  const CARDS = [
    {
      img: Parallax_1,
      title: <>Tudo fica registrado<br />e pronto para a auditoria.</>,
      blocks: [
        "Cada ação realizada gera um registro automático, com:",
        [
          "Data e hora da execução",
          "Nome do responsável",
          "Checklist aplicado e status da tarefa",
          "Evidência visual (foto, assinatura, geolocalização)",
          "Histórico consolidado do ativo",
        ],
        "Essas informações alimentam relatórios prontos para auditorias, compliance, planejamento e análise de performance. Nada se perde, nada se omite — tudo fica à disposição de quem precisa decidir com confiança.",
      ],
    },
    {
      img: Parallax_2,
      title: "A equipe executa com segurança, clareza e eficiência.",
      blocks: [
        "Cada técnico recebe um checklist detalhado com tudo o que precisa:",
        [
          "Instruções passo a passo",
          "Fotos de referência",
          "Histórico técnico do ativo",
          "Localização geográfica",
          "Confirmação por evidência (fotos, assinatura, tempo de execução)",
        ],
        "Toda ação realizada é rastreável, do chamado à conclusão. Menos erros, menos retrabalho, mais confiança na execução.",
      ],
    },
    {
      img: Parallax_3,
      title: "O sistema agenda e atribui de forma inteligente, automática e sem fricção.",
      blocks: [
        "Assim que um risco é identificado, o WisePrevent transforma esse dado em uma ação concreta. A tarefa é criada automaticamente com todos os parâmetros definidos:",
        [
          "Qual ativo precisa de atenção",
          "Onde está localizado",
          "Qual a gravidade do risco",
          "Quem será responsável pela execução",
        ],
        "Sem formulários, sem e-mails, sem planilhas. A equipe certa recebe a missão, com prioridade e prazo definidos — tudo organizado, direto na agenda de campo. Você ganha agilidade, precisão e rastreabilidade desde o primeiro segundo.",
      ],
    },
    {
      img: Parallax_4,
      title: "O sensor detecta o risco em tempo real, com precisão invisível aos olhos.",
      blocks: [
        "Sensores inteligentes monitoram continuamente seus ativos, detectando alterações mínimas de pressão, temperatura, vibração ou fluxo. Essas variações, muitas vezes imperceptíveis, são o primeiro sinal de que algo está prestes a falhar.",
        "Assim que detectado, o dado é transmitido automaticamente para o WisePrevent, iniciando um fluxo de resposta imediata.",
      ],
    },
  ];

  return (
    <>
      <S.Content>
        {CARDS.map((card, i) => (
          <S.Card
            key={i}
          >
            <img src={card.img} alt="" loading="lazy" />
            <S.TextBox>
              <h3>{card.title}</h3>
              {card.blocks.map((block, k) =>
                Array.isArray(block) ? (
                  <ul key={k}>{block.map((li, j) => <li key={j}>● <span>{li}</span></li>)}</ul>
                ) : (
                  <p key={k}>{block}</p>
                )
              )}
            </S.TextBox>
          </S.Card>
        ))}
      </S.Content>

      <S.ContentMobile>
        {CARDS.map((card, i) => (
          <S.Card
            key={i}
          >
            <img src={card.img} alt="" loading="lazy" />
            <S.TextBox>
              <h3>{card.title}</h3>
              {card.blocks.map((block, k) =>
                Array.isArray(block) ? (
                  <ul key={k}>
                    {block.map((li, j) =>
                      <li key={j}>● <span>{li}</span></li>)}</ul>
                ) : (
                  <p key={k}>{block}</p>
                )
              )}
            </S.TextBox>
          </S.Card>
        ))}
      </S.ContentMobile>
    </>
  );
};
